/* eslint-disable class-methods-use-this */
import React from 'react';
import BaseClass from 'components/BaseClass';
import { wrapComponent } from 'utils/framework';
import Authentication from 'Authentication';
import userUtils from 'utils/User';
import skuHelpers from 'utils/skuHelpers';
import { HEADER_VALUE } from 'constants/authentication';
import helpersUtils from 'utils/Helpers';

const { deferTaskExecution } = helpersUtils;

const anonymous = userUtils.isAnonymous;

class ProductLove extends BaseClass {
    state = {
        hover: false,
        isAnonymous: false
    };

    render() {
        const childProps = {
            handleOnClick: this.handleOnClick,
            mouseEnter: this.mouseEnter,
            mouseLeave: this.mouseLeave,
            isActive: skuHelpers.isSkuLoved(this.props.sku.skuId),
            hover: this.state.hover,
            sku: this.props.sku,
            skuLoveData: {
                loveSource: this.props.loveSource,
                skuId: this.props.sku.skuId,
                productId: this.props.productId,
                isOnlyFewLeft: this.props.sku.isOnlyFewLeft || false
            },
            isAnonymous: this.state.isAnonymous
        };

        if (typeof this.props.children === 'function') {
            return this.props.children(childProps);
        }

        return (
            <React.Fragment>
                {React.Children.map(this.props.children, (child, index) =>
                    React.cloneElement(child, {
                        key: index.toString(),
                        ...childProps
                    })
                )}
            </React.Fragment>
        );
    }

    componentDidMount() {
        this.setState({ isAnonymous: anonymous() });
    }

    handleOnClick = (e, skuLoveData, sku) => {
        e.preventDefault();
        e.stopPropagation();

        deferTaskExecution(() => {
            const isAnonymous = anonymous();
            const { imageProps, analyticsContext, currentProduct } = this.props;
            let isSkuLoved;
            const analyticsData = {
                context: analyticsContext,
                nextPageContext: analyticsContext
            };

            Authentication.requireAuthentication(null, null, analyticsData, null, false, HEADER_VALUE.USER_CLICK)
                .then(() => {
                    isSkuLoved = skuHelpers.isSkuLoved(this.state.skuId);

                    // Don't handle love request if user was anonymous and “loved” an item that was
                    // already loved by her, since this would mark the product as unloved.
                    if (!isAnonymous || !isSkuLoved) {
                        this.props.showMyListsModal(true);
                        this.props.setSkuLoveData(skuLoveData);
                        this.props.setSkuLoveImageData(imageProps);
                        this.props.setCurrentProduct({ ...sku, ...currentProduct });
                    }
                })
                .catch(() => {});
        });
    };

    mouseEnter = e => {
        if (!Sephora.isTouch) {
            e.stopPropagation();
            this.setState({ hover: true });
        }
    };

    mouseLeave = e => {
        if (!Sephora.isTouch) {
            e.stopPropagation();
            this.setState({ hover: false });
        }
    };
}

export default wrapComponent(ProductLove, 'ProductLove', true);
